import AtencionSinTurnoIcon from "_+_Portal/assets/images/generico/AtencionSinTurnoIcon";
import ConsultaIcon from "_+_Portal/assets/images/generico/ConsultaIcon";
import EstudioIcon from "_+_Portal/assets/images/generico/EstudioIcon";
import LaboratorioIcon from "_+_Portal/assets/images/generico/LaboratorioIcon";
import MiGrupoFamiliarIcon from "_+_Portal/assets/images/generico/MiGrupoFamiliarIcon";
import MiInformeIcon from "_+_Portal/assets/images/generico/MiInformeIcon";
import MiMedicoIcon from "_+_Portal/assets/images/generico/MiMedicoIcon";
import MiPerfilIcon from "_+_Portal/assets/images/generico/MiPerfilIcon";
import MiTurnoIcon from "_+_Portal/assets/images/generico/MiTurnoIcon";
import MisLaboratoriosIcon from "_+_Portal/assets/images/generico/MisLaboratoriosIcon";
import NotifiacionIcon from "_+_Portal/assets/images/generico/NotificacionIcon";
import OncologiaIcon from "_+_Portal/assets/images/generico/OncologiaIcon";
import OrdenesDigitalesIcon from "_+_Portal/assets/images/generico/OrdenesDigitalesIcon";
import RecetaDigitalIcon from "_+_Portal/assets/images/generico/RecetaDigitalIcon";
import SalirIcon from "_+_Portal/assets/images/generico/SalirIcon";
import SugerenciaIcon from "_+_Portal/assets/images/generico/SugerenciaIcon";
import TestPcrIcon from "_+_Portal/assets/images/generico/TestPcrIcon";
import VideoConsultaIcon from "_+_Portal/assets/images/generico/VideoConsultaIcon";
import VideoTutorial from "_+_Portal/assets/images/generico/VideoTutorial";
import AyudaPreguntaIcon from "_+_Portal/assets/images/generico/AyudaPreguntaIcon";
import PhoneIcon from "_+_Portal/assets/images/generico/PhoneIcon";
import candado from "../../../assets/images/generico/candado.png";
import RecetaIcon from "_+_Portal/assets/images/generico/RecetaIcon";
import ClipboardMinusIcon from "_+_Portal/assets/images/generico/ClipboardMinusIcon";
import HomeIcon from "_+_Portal/assets/images/generico/HomeIcon";

export const filterContents = (removeFromTheSidebar, items) => {
  return items.filter(
    (item) => item.link && !includeCustom(removeFromTheSidebar, item.link)
  );
};

const includeCustom = (array, link) => {
  let include = false;
  for (let index = 0; index < array.length; index++) {
    const element = array[index];
    if (element.link === link && !element.active) {
      include = true;
    }
  }
  return include;
};

export const listItems = (setItemSelected, url, configState) => {
  let removeFromTheSidebar = [
    {
      link: "/estudios",
      active: configState?.config?.data?.opcEstudios,
    },
    {
      link: "/misInformes",
      active: configState?.config?.data?.opcEstudios,
    },
    {
      link: "/misLaboratorios",
      active: configState?.config?.data?.opcMisLaboratorios,
    },
    {
      link: "/consultamedica",
      active: configState?.config?.data?.opcConsultaMedica,
    },
    {
      link: "/laboratorio",
      active: configState?.config?.data?.opcLaboratorio,
    },
    {
      link: "/misRecetas",
      active: configState?.config?.data?.opcMisRecetas,
    },
    {
      link: "/videoConsulta",
      active: configState?.config?.data?.opcVideoLlamada,
    },
    {
      link: "/recetasdigitales",
      active: configState?.config?.data?.opcRecetaDigital,
    },
    {
      link: "/videoTutoriales",
      active: configState?.config?.data?.opcVideotutoriales,
    },
    {
      link: "/atencionSinTurno",
      active: configState?.config?.data?.opcAtencionSinTurnoPrevio,
    },
    {
      link: "*ayuda*",
      active: configState?.config?.data?.opcBot ?? false,
    },
    {
      link: "/notificaciones",
      active: configState?.config?.data?.opcNotificaciones,
    },
    {
      link: "/oncologia",
      active: configState?.config?.data?.opcOncologia,
    },
    {
      link: "/testpcr",
      active: configState?.config?.data?.opcAccesoTestRapidoPCR,
    },
    {
      link: "/ordenesDigitales",
      active: configState?.config?.data?.opcOrdenDigital,
    },
    {
      link: "/certificados",
      active: configState?.config?.data?.opcCertificados,
    },
    {
      link: "/beneficiosDim",
      active: configState?.config?.data?.opcBeneficios,
    },
    {
      link: "/preguntasFrecuentes",
      active: configState?.config?.data?.opcPreguntasFrecuentes ?? true,
    },
    {
      link: "/autocheckin",
      active: configState?.config?.data?.opcHome,
    },
    {
      link: "/consultamedica",
      active: !configState?.config?.data?.opcHome,
    },
    {
      link: "/estudios",
      active: !configState?.config?.data?.opcHome,
    },
    {
      link: "/laboratorio",
      active: !configState?.config?.data?.opcHome,
    },
  ];

  let listToRender = {
    titles: ["Turnos", "Resultados", "Información"],
    contents: [
      [
        {
          title: "Home",
          icon: <HomeIcon color={"var(--color-white)"} />,
          link: "/autocheckin",
        },
        {
          title: "Ordenes médicas",
          icon: <OrdenesDigitalesIcon color={"var(--color-white)"} />,
          link: "/ordenesDigitales",
        },
        {
          title: "Ver recetas",
          icon: <RecetaIcon color={"var(--color-white)"} />,
          link: "/misRecetas",
        },
        {
          title: "Ver Certificados",
          icon: <ClipboardMinusIcon color={"var(--color-white)"} />,
          link: "/certificados",
        },
        {
          title: "Consultas Médicas",
          icon: <ConsultaIcon color={"var(--color-white)"} />,
          link: "/consultamedica",
        },
        {
          title: "Estudios",
          icon: <EstudioIcon color={"var(--color-white)"} />,
          link: "/estudios",
        },
        {
          title: "Laboratorio",
          icon: <LaboratorioIcon color={"var(--color-white)"} />,
          link: "/laboratorio",
        },
        {
          title: "Recetas digitales",
          icon: <RecetaDigitalIcon color={"var(--color-white)"} />,
          link: "/recetasdigitales",
        },
        {
          title: "Próximos turnos",
          icon: <MiTurnoIcon color={"var(--color-white)"} />,
          link: "/proximosTurnos",
        },
        {
          title: "Video consulta",
          icon: <VideoConsultaIcon color={"var(--color-white)"} />,
          link: "/videoConsulta",
        },
        {
          title: "Atención sin turno",
          icon: <AtencionSinTurnoIcon color={"var(--color-white)"} />,
          link: "/atencionSinTurno",
        },
        {
          title: "Test PCR (COVID-19)",
          icon: <TestPcrIcon color={"var(--color-white)"} />,
          link: "/testpcr",
        },
        {
          title: "Oncología",
          icon: <OncologiaIcon color={"var(--color-white)"} />,
          link: "/oncologia",
        },
      ],
      [
        {
          title: "Mis laboratorios",
          icon: <MisLaboratoriosIcon color={"var(--color-white)"} />,
          link: "/misLaboratorios",
        },
        {
          title: "Mis informes",
          icon: <MiInformeIcon color={"var(--color-white)"} />,
          link: "/misInformes",
        },
      ],
      [
        {
          title: "Notificaciones",
          icon: <NotifiacionIcon color={"var(--color-white)"} />,
          link: "/notificaciones",
        },

        {
          title: "Mi perfil",
          icon: <MiPerfilIcon color={"var(--color-white)"} />,
          link: "/perfil",
        },
        {
          title: "Mi grupo familiar",
          icon: <MiGrupoFamiliarIcon color={"var(--color-white)"} />,
          link: "/GrupoFamiliar",
        },
        {
          title: "Mis médicos",
          icon: <MiMedicoIcon color={"var(--color-white)"} />,
          link: "/misMedicos",
        },
        {
          title: "Beneficios",
          icon: <SugerenciaIcon color={"var(--color-white)"} />,
          link: "/beneficiosDim",
        },
        {
          title: "Hacer sugerencias",
          icon: <SugerenciaIcon color={"var(--color-white)"} />,
          link: "/sugerencia",
        },
        {
          title: "Preguntas frecuentes",
          icon: <AyudaPreguntaIcon color={"var(--color-white)"} />,
          link: "/preguntasFrecuentes",
        },
        {
          title: "Video tutoriales",
          icon: <VideoTutorial color={"var(--color-white)"} />,
          link: "/videoTutoriales",
        },
        {
          title: "Ayuda",
          icon: <PhoneIcon color={"var(--color-white)"} />,
          link: "*ayuda*",
          fun: () => {
            window.open(`https://wa.me/5491166485555`, "_blank");
          },
        },
        {
          title: "Salir",
          icon: <SalirIcon color={"var(--color-white)"} />,
          link: "/",
        },
      ],
    ],
  };

  listToRender.contents = listToRender.contents.map((content) => {
    return filterContents(removeFromTheSidebar, content);
  });

  listToRender.contents.map((content, index1) => {
    content.map((item, index2) => {
      const element = item;
      if (element.link === url) {
        setItemSelected({ [index1]: index2 });
      }
    });
  });

  return listToRender;
};
